export default __webpack_public_path__ + "static/media/rk-dropdown.673e4f9a.webp";